import React, {Component} from 'react';
import {
    Select, Spin, Input, Icon
} from 'antd';

export default class SelectUser extends Component {
    constructor(props) {
        super(props);

        if (props.clientID > 0 && props.clientDetailID > 0) {
            let label = <span><p
                style={{
                    textAlign: 'left',
                    position: 'relative',
                    display: 'inline-flex',
                    fontWeight: '500',
                    textTransform: 'capitalize',
                    fontSize: '13px',
                }}>
                    {props.contactName}
                </p>
                <p
                    style={{
                        float: 'right',
                        position: 'relative',
                        display: 'inline-flex',
                        fontSize: '13px',
                    }}>
                    {props.contactPhone}
                </p>
                <p
                    className={'client-address'}
                    style={{
                        position: 'relative',
                        fontSize: '12px',
                        color: 'rgba(0, 0, 0, 0.43)',
                        display: 'block',
                        whiteSpace: 'initial',
                    }}>
                    {props.clientAddress}
                </p></span>;

            let defaultClientData = {key: props.clientDetailID.toString(), label: label};

            this.state = {
                fetching: false,
                data: [],
                clientDetails: [],
                selectedClientDetail: defaultClientData,
            }
        } else {
            this.state = {
                fetching: false,
                data: [],
                clientDetails: [],
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.clientDetailID !== nextProps.clientDetailID) {
            if (nextProps.clientDetailID === 0) {
                this.setState({
                    selectedClientDetail: {
                        key: '0',
                        label: <div
                            style={{color: '#108ee9', display: this.props.clientID > 0 ? 'block' : 'none'}}><Icon
                            type="plus"/> THÊM MỚI</div>
                    }
                });
            }
        }
    }

    componentWillMount() {
        if (this.props.clientID > 0 && this.props.clientDetailID > 0) {
            this.fetchClientDetail(this.props.clientID);
        }
    }

    fetchUser = (value) => {
        if (value && value.length >= 3) {
            this.setState({fetching: true});

            fetch(`https://itracking.vn/gapi/v3.0/user/${value}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Auth-Token': 'AIzaSyAs6DZzfPQGgKsZD28f_nsp5v-D43zi-So',
                }
            })
                .then(response => response.json())
                .then((body) => {
                    if (body.data && body.data.length > 0) {
                        const data = body.data.map((user) => {
                            user.value = user.username;
                            user.clientID = user.key;
                            user.model = 'itracking';

                            return user;
                        });

                        this.setState({data: data, fetching: false});
                    } else {
                        this.setState({fetching: false});
                    }
                });
        }
    };

    fetchClientDetail = (clientID) => {
        if (clientID && clientID > 0) {
            this.setState({fetching: true});

            let bToken = `Bearer ${this.props.token}`;

            fetch(`https://api.dinhviso.com.vn/teamweek/clientDetails/${this.props.projectID}/${clientID}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': bToken,
                }
            })
                .then(response => response.json())
                .then((body) => {
                    if (body.clientDetails && body.clientDetails.length > 0) {
                        let clientDetails = body.clientDetails.map((clientDetail) => {
                            clientDetail.value = clientDetail.id.toString();
                            clientDetail.key = clientDetail.id.toString();

                            return clientDetail;
                        });

                        this.setState({clientDetails: clientDetails, fetching: false});
                    } else {
                        this.setState({clientDetails: [], selectedClientDetail: undefined, fetching: false});
                    }
                });
        }

    };

    render() {
        return (
            <span>
                <Input.Group compact>
                    <Select
                        size={'large'}
                        mode={'combobox'}
                        style={{textAlign: 'left', width: '35%'}}
                        filterOption={false}
                        notFoundContent={'Không tìm thấy!'}
                        placeholder="Chọn tài khoản"
                        defaultValue={this.props.username ? this.props.username : ''}
                        onSearch={this.fetchUser}
                        onSelect={(value) => {
                            if (value.length > 0) {
                                this.setState({selectedClientDetail: undefined});
                                let arrUser = this.state.data.filter(user => user.value === value);
                                if (arrUser && arrUser.length > 0) {
                                    let selectedUserID = parseInt(arrUser[0].key);

                                    if (this.props.projectID > 0) {
                                        this.fetchClientDetail(selectedUserID);
                                    }

                                    this.props.setSelectedUserID(selectedUserID);
                                    this.props.handleChange(false, 'saveClientDetail');
                                    this.props.handleChange(0, 'clientDetailID');
                                    this.props.handleChange(arrUser[0], 'client');
                                }
                            }
                        }}
                    >
                        {
                            this.state.data.map(data =>
                                <Select.Option key={data.key.toString()} value={data.value}>
                                    {data.value}
                                </Select.Option>)
                        }
                    </Select>
                    {
                        this.state.fetching ?
                            <Spin size="small" style={{position: 'absolute', top: '3px', right: '13px'}}/> : null
                    }
                    <Select
                        className={'select-user'}
                        size={'large'}
                        style={{textAlign: 'left', width: '65%'}}
                        filterOption={false}
                        placeholder="Chọn thông tin tài khoản"
                        labelInValue
                        value={this.state.selectedClientDetail}
                        onSelect={(value) => {
                            this.setState({selectedClientDetail: value});

                            if (parseInt(value.key) > 0) {
                                this.props.handleChange(parseInt(value.key), 'clientDetailID');

                                if (this.state.clientDetails && this.state.clientDetails.length > 0) {
                                    this.state.clientDetails.map((clientDetail) => {
                                        if (clientDetail.id === parseInt(value.key)) {
                                            this.props.handleChange(clientDetail.contactName, 'contactNameUpdate');
                                            this.props.handleChange(clientDetail.phone, 'contactPhoneUpdate');
                                            this.props.handleChange(clientDetail.address, 'clientAddress');
                                            this.props.handleChange(clientDetail.latitude, 'latitude');
                                            this.props.handleChange(clientDetail.longitude, 'longitude');
                                        }
                                    });
                                }

                                this.props.handleChange(false, 'saveClientDetail');
                            } else if (parseInt(value.key) === 0) {
                                this.props.handleChange(true, 'saveClientDetail');
                            }
                        }}
                    >
                        <Select.Option key={'0'} value={'0'}>
                            {<div
                                style={{color: '#108ee9', display: this.props.clientID > 0 ? 'block' : 'none'}}><Icon
                                type="plus"/> THÊM MỚI</div>}
                        </Select.Option>
                        {this.state.clientDetails.map(clientDetail =>
                            <Select.Option
                                key={clientDetail.key.toString()}
                                value={clientDetail.value}>
                                <p
                                    style={{
                                        textAlign: 'left',
                                        position: 'relative',
                                        display: 'inline-flex',
                                        fontWeight: '500',
                                        textTransform: 'capitalize',
                                        fontSize: '13px',
                                    }}>
                                    {clientDetail.contactName}
                                </p>
                                <p
                                    style={{
                                        float: 'right',
                                        position: 'relative',
                                        display: 'inline-flex',
                                        fontSize: '13px',
                                    }}>
                                    {clientDetail.phone}
                                </p>
                                <p
                                    className={'client-address'}
                                    style={{
                                        position: 'relative',
                                        fontSize: '12px',
                                        color: 'rgba(0, 0, 0, 0.43)',
                                        display: 'block',
                                        whiteSpace: 'initial',
                                    }}>
                                    {clientDetail.address}
                                </p>
                            </Select.Option>)}
                    </Select>
                </Input.Group>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/itracking/select-user.js